export function replaceDoubleSlashWithSingleSlash(filePath) {
    return filePath.replace(/\/{2,}/g, "/");
}
export function encodeFilePath(filePath) {
    return filePath.split("/").map(encodeURIComponent).join("/");
}
export const cleanQuickOrderEntryInput = (str) => str.replace(/“|”/g, '"');
export const trimSlash = (str) => str.trim().replace(/^\/|\/$/g, "");
